<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    width="2124.332"
    height="1031.05"
    viewBox="0 0 2124.332 1031.05"
  >
    <path
      id="Path_225"
      data-name="Path 225"
      d="M-37.525,88.456h0l15.955,4.189,16.489,4.1,17.911,4.629,17.453,4.646,24.305,6.817L77.6,119.295l18.1,4.783,16.626,4.165,18.54,4.812,19.891,5.163,16.255,3.961,16.334,3.9,15.729,3.774,18.334,4.4,17.081,4.05,19.594,4.646,19.2,4.395,22.241,5.262,19.757,4.674,18.54,4.078,17.779,3.91,19.195,4.352,15.214,3.282,8.966,1.735,9.183,1.777,6.473,1.408,7.823,1.458,8.094,1.529,8.612,1.627,8.477,1.521,7.178,1.175,10.19,1.667,9.958,1.4,9.672,1.359,9.593,1.348,9.629,1.353,9.7,1.02,8.038.727,9.912.9,9.858.734,7.335.546,7.413.376,9.555.484,9.621.1,7.514.159,8.642-.057,9.55-.185,8.682-.272,8.945-.415L625,215.514l8.406-.859,9.287-1.07,8.242-1.069,9.677-1.467,8.592-1.58,9.634-1.772,8.261-1.921,9.516-2.33,8.234-2.375,8.811-2.725,7.463-2.5,8.687-3.166,5.5-2.182,5.863-2.5,7.306-3.32,5.56-2.9,6.627-3.436,5.972-3.587,7.078-4.478L780,166.14l5.663-4.352,6.635-5.375,6.771-5.9,6.69-6.084,4.868-5.386,4.5-5.184,5.183-6.172,4.385-5.8,3.77-5.545,4.405-6.771,3.328-5.874,3.768-7.061,5.2-12.479,4.075-10.685L852.1,63.422l2.421-10.131,1.812-9.577.835-10.918.251-6.232-.087-7.265-.244-11.185L856.361.6l-1.224-8.5-1.517-9-2.3-9.422-2.838-9.429-3.214-9.124L840.9-55.991l-4.1-8.3-4.7-9.093-4.5-7.794-4.43-7-3.413-5.309-4.58-6.311-4.121-5.532-4.505-5.472-4.493-5.409-5.533-6.238-4.028-4.154-6.414-6.413-5.649-5.335L774.95-143.2l-4.55-3.871s-2.582-2.07-5.977-4.789c-1.069-.856-2.852-2.271-5.1-4.051-1.386-1.1-3.332-2.577-5.593-4.276-1.477-1.11-4.629-3.3-8.2-5.748-1.469-1.008-3.756-2.55-6.5-4.4-1.707-1.146-4.224-2.728-7.152-4.533-2.021-1.245-5.292-3.179-8.916-5.3-1.365-.8-3.332-1.884-5.79-3.211l-5.346-2.883c-1.458-.787-3.229-1.683-5.4-2.748-3.028-1.484-6.458-3.088-9.744-4.6-1.548-.712-4.573-2.036-7.985-3.515-1.508-.654-4.279-1.768-7.649-3.1-1.824-.72-5.222-1.98-9.405-3.506-2.879-1.051-6.827-2.382-11.218-3.822-1.764-.578-4.364-1.357-7.7-2.32-4.843-1.4-10.922-3.082-16.9-4.713-3.16-.863-9.273-2.155-16.212-3.535-3.655-.727-7.5-1.468-11.387-2.2-3.325-.63-7.57-1.257-11.741-1.821-1.765-.239-6.819-.754-13.086-1.364-4-.39-8.495-.671-12.993-.885-2.846-.136-9.338-.142-16.886-.091-3.839.026-9.51.478-15.966,1.143a141.2,141.2,0,0,0-14.267,2.4c-3.5.742-8.388,2.095-13.895,3.745a103.1,103.1,0,0,0-11.329,4.132,110.844,110.844,0,0,0-10.786,5.636c-1.589.921-3,1.778-4.2,2.513L477.654-201l-4.693,3.845-3.812,3.374-3.361,3.533-3.49,3.871-3.86,5.146-2.813,4.256-2.09,3.4-3.076,5.576-2.162,4.834-1.121,3.217-1.349,4.023-1.975,7.951-1.4,6.795-.723,7.495-.477,8.4.64,11.117,1.765,12.517L447.28-85.7l3.778,12.432,5.176,12.82,5.354,11.627L467.7-37.762l7.028,10.7,8.252,12.149,8.985,11.161L502.175,8.17l10.876,10.581,11.8,10.332,10.606,8.477L546.9,45.934l11.945,7.9,12.015,7.084,13.1,7.231L597.148,74.3l13.984,5.721,13.884,4.919,13.706,4.446,11.952,3.2,5.01,1.208,5.717,1.245,7.026,1.379,5.8,1.138,7.124,1,8.537,1.016,7.153.925,7.922.623,7.07.7,6.241.443,5.254.25,5.066.136,8.323-.091,8.832-.108,9.429-.227,10.5-.546,9.948-.563,8.559-.751,8.687-.928,8.891-1.1,9.17-1.3,10.8-1.567,17.239-3.386,18.466-3.627,12.724-2.907,11.478-2.674,11.227-2.836,13.375-3.378,12.621-3.449,12.617-3.56L944.2,66.064,956.792,62.3l12.91-3.874,11.283-3.5,10.964-3.4,12.219-3.683,10.962-3.315,11.641-3.455,11.616-3.308,11.065-2.884,10.225-2.665,7.07-1.784L1078,28.02l9.26-2.042,9.881-1.677,10.343-1.49,11.536-1.3,7.912-.8,8.4-.7,9.994-.518,7.876-.19,8.783-.124,9.164.113,5.872.087,8.262.287,8.5.494,9.737.8,7.162.592,5.244.737,7.457.665,8.217,1.155,7.157,1.23,9.946,1.733,9.272,1.788,10.836,2.4,8.978,2.114,12.57,3.243,10.231,3,8.969,2.68,10.5,3.456,11.776,4.3,8.189,3.071,10.707,4.376,12.569,5.208,10.087,4.824,8.089,3.941,7.312,3.887,8.611,4.841,8.527,5.027,9.427,5.818,8.967,5.8,10.472,7.479,9.18,6.695,7.535,5.9,7.872,6.747,10.035,9.033,7.466,7.339,7.475,8.019,7.782,9.052,8.918,11.037,9.226,14.278,5.889,12.241,7.5,18.816,4.748,13.144,4.455,17.58,4.013,19.422,3,18.395,2.818,20.967,2.286,25.742.468,22.6.013,12.638-1.565,19.366-2.8,19.92-3.839,16.035-3.162,9.487-4.037,10.479-4.259,7.948-3.051,5.344-4.3,4.942-5.471,5.795-6.235,4.467-7.227,3.979-7.8,2.864-8.612,1.573-8.9.844-14.858-.873-11.9-2.715-12.73-4.692-12.348-5.848-17.285-10.977-9.51-9.582-6.407-7.654-5.993-9.588-5.2-11.6-3.644-12.327-1.166-9.664-.207-9.04-.21-11.431,2.259-16.077,2.912-13.117,3.99-11.823,4.99-12.848,7.6-15.295,7.985-12.537,6.659-9.628,7.9-9.48,6.207-6.565,10.593-10.694,8.106-7.421,10.376-8.86,10.846-8.671,13.3-9.747,11.939-8.681,39.8-24.975,23.4-14.075,14.689-7.814,13.008-5.9,14.433-6.9,14.468-5.871,13.131-5.05,18.615-6.172,19.237-5.346,17.051-4L1689,121.01l14.6-2.581,9.386-1.277,11.607-1.544,12.689-1.343,13.391-1.121,16.892-.827,17.833-.791,20.7-.24,18.956.154,24.15.734,23.252.779,23.343,1.076,24.5,1.431,22.625,1.322L1966,118.13l16.464.945,10.923.627"
      transform="translate(78.758 526.207) rotate(-8)"
      fill="none"
      stroke="#ced5cc"
      stroke-width="53"
      opacity="0.30"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
svg {
  width: 100%;
  height: auto;
  transform: scale(1.5) translate(14%, 12%);
}

@media (max-width: 1263px) {
  svg {
    transform: scale(1.7) translate(14%, -4%);
  }
}

@media (max-width: 959px) {
  svg {
    transform: scale(2.3) translate(16%, 3%);
  }
}

@media (max-width: 767.98px) {
  svg {
    transform: scale(3.1) translate(16%, 13%);
  }
}

@media (max-width: 599px) {
  svg {
    transform: scale(3.5) translate(16%, 15%);
  }
}

@media (max-width: 350px) {
  svg {
    transform: scale(4) translate(16%, 18%);
  }
}
</style>

<style>
/* Animation */
.our-practice-animation {
  stroke-dasharray: 4090;
  stroke-dashoffset: 0;
  -webkit-animation: animate-Path_225 5s ease-in forwards;
  animation: animate-Path_225 5s ease-in forwards;
}

@-webkit-keyframes animate-Path_225 {
  from {
    stroke-dashoffset: 4090;
  }
}

@keyframes animate-Path_225 {
  from {
    stroke-dashoffset: 4090;
  }
}
</style>